<template>
  <div
    class="card-running d-flex p-a-16 flex-row justify-content-between align-start align-self-stretch"
  >
    <div class="card-running-texts d-flex flex-column align-items-start">
      <p class="f-Overpass f-16 f-w-600 my-0" style="color: #212121">
        {{ layanan }}
      </p>

      <div
        class="text-machine d-flex align-items-center f-12 f-w-400"
        style="gap: 4px; color: #6f7287"
      >
        <img src="../../../assets/icons/machine.svg" alt="machine" />
        <p class="my-1">{{ namaMesin }}</p>
      </div>

      <div
        class="text-machine d-flex align-items-center f-12 f-w-400"
        style="gap: 4px; color: #6f7287"
      >
        <img src="../../../assets/icons/location.svg" alt="location" />
        <p class="my-1">{{ namaOutlet }}</p>
      </div>
    </div>

    <pomodoroTimer :limit="durasi" :time-left="timeLeft" />
  </div>
</template>

<script>
import pomodoroTimer from "./pomodoroTimer.vue";
export default {
  name: "runningCard",
  components: {
    pomodoroTimer,
  },
  props: {
    layanan: String,
    namaMesin: String,
    namaOutlet: String,
    durasi: Number,
    timeFinish: String,
    idmesin: String,
  },
  data() {
    return {
      timeLeft: 0,
      timePassed: 0,
      timerInterval: null,
			topic: null,
    };
  },
  mounted() {
    this.listenSnapLeftTime()
  },

  methods: {
    startTimer() {
      this.timerInterval = setInterval(() => (this.timeLeft -= 1000), 1000);
    },
    listenSnapLeftTime() {
      this.topic = 'report.heartbeat.' + this.idmesin
      this.$socket.on(this.topic, (msg) => {
        this.timeLeft = msg.tl
        if (msg.tl < 1) {
          this.unsibscribe()
        }
      })
    },
		unsibscribe() {
			this.$socket.off(this.topic)
			this.$emit('finish')
		}
  },
  watch: {
    timeLeft() {
			if (this.timeLeft < 0) this.unsibscribe()
      clearInterval(this.timerInterval)
      this.startTimer()
    }
  },
};
</script>

<style scoped>
.card-running {
  gap: 16px;
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}

.card-running-texts {
  gap: 8px;
  flex: 1 0 0;
}
</style>
